import { Icon, IconProps } from "../";

export const TriangleTopIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M11.134 5.5C11.5189 4.83333 12.4811 4.83333 12.866 5.5L19.7942 17.5C20.1791 18.1667 19.698 19 18.9282 19H5.0718C4.302 19 3.82088 18.1667 4.20578 17.5L11.134 5.5Z" />
    </Icon>
  );
};
